<template>
    <header class="order-header" :class="{'order-header--is-mobile': isMobile}">
        <div class="order-header-title">{{ title }}</div>
        <div v-if="!isMobile" class="order-header-info">{{ info }}</div>
        <div class="order-header-actions">
            <a href="#" id="btnClosePhotoEditor" @click.prevent="$emit('close-photo-editor')">
                <span class="material-icon icon-clear"></span>
            </a>
        </div>
    </header>
</template>

<script>
  import photoEditorHeader from 'src/mixins/photoEditorHeaderComponent';

  export default {
    mixins: [photoEditorHeader],
  };
</script>
